import { render, staticRenderFns } from "./WorkdayForm.vue?vue&type=template&id=f1340b84&scoped=true&"
import script from "./WorkdayForm.vue?vue&type=script&lang=js&"
export * from "./WorkdayForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkdayForm.vue?vue&type=style&index=0&id=f1340b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1340b84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBreadcrumbs,VBtn,VCard,VForm,VIcon,VTextField})
